module.exports = __webpack_public_path__ + "media/app-store-detail/apple_icon-28c9035d.svg";